import { FleekError } from './FleekError';

type Site = {
  id?: string;
  slug?: string;
};

type SiteHasNoSourceProviderErrorOptions = {
  site: Site;
};

export class SiteHasNoSourceProviderError extends FleekError<SiteHasNoSourceProviderErrorOptions> {
  public name = 'SiteHasNoSourceProviderError';

  toString = () => {
    if (this.data.site.slug) {
      return `Site ${this.data.site.slug} does not have a source provider.`;
    }

    return `Site does not have a source provider.`;
  };
}
